var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReadAcross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 1.66673V5.55041C8.33333 5.73139 8.33333 5.82187 8.30575 5.89386C8.27974 5.96176 8.24529 6.01106 8.19048 6.05885C8.13238 6.10951 8.03827 6.14398 7.85006 6.21293C5.45743 7.08944 3.75 9.38699 3.75 12.0833C3.75 15.5351 6.54822 18.3333 10 18.3333C13.4518 18.3333 16.25 15.5351 16.25 12.0833C16.25 9.38699 14.5426 7.08944 12.1499 6.21293C11.9617 6.14398 11.8676 6.10951 11.8095 6.05885C11.7547 6.01106 11.7203 5.96176 11.6942 5.89386C11.6667 5.82187 11.6667 5.73139 11.6667 5.55041V1.66673M7.08333 1.66666H12.9167",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadAcross);
export default __webpack_public_path__ + "static/media/Read-Across.2a6ad572f534e303bc8c14a11ad2c249.svg";
export { ForwardRef as ReactComponent };